export enum ERequestForDeliveryAssigner {    
    None,
    Tender,
    Rating,
    Bidding,
    Manual
}